export var SsoEnforcementType;
(function (SsoEnforcementType) {
    SsoEnforcementType["DISABLED"] = "disabled";
    SsoEnforcementType["OPTIONAL"] = "optional";
    SsoEnforcementType["REQUIRED_FOR_ALL_MEMBERS"] = "required_for_all_members";
    SsoEnforcementType["REQUIRED_FOR_COMPANY_DOMAIN_MEMBERS"] = "required_for_company_domain_members";
    /**
     * We are splitting the sso enforcement into two parts per
     * workspace(external users requirement) and for domain(domain users requirement).
     *
     * This requires us to map back the old enforcementType from the new fields, but
     * there could be states(combinations) which are invalid, so we need this value.
     **/
    SsoEnforcementType["INVALID"] = "invalid";
})(SsoEnforcementType || (SsoEnforcementType = {}));
